<template>
<div class="odr-short"
     :class="{
         'odr-short_less': less,
         'odr-short_more': more,
         [`odr-short_background-${color}`]: true
     }"
     :style="`max-width: ${width} !important; max-height: ${eHeight} !important`">
    <div class="odr-short__content" ref="content">
        <slot></slot>
    </div>
</div>
</template>

<script>
import '../styles/short.scss'

export default {
    props: {
        color: {
            default: 'light',
            _descr: 'use color="plain" for white backgrounds',
        },
        height: {
            type: String,
            required: true,
            _descr: 'max-height of the area',
        },
        width: {
            type: String,
            default: '100%',
            _descr: 'width of the area',
        },
        expanded: {
            type: String,
            _descr: 'initial state',
        },
    },
    data () {
        return {
            fits: false,
            collapsed: this.expanded === undefined,
        }
    },
    mounted () {
        if (window.__odrBus) {
            window.__odrBus.$on('possible-resize', this.checkFitting)
        }
        Array.from(this.$el.querySelectorAll('[data-short-trigger]')).forEach(element => {
            element.addEventListener('click', () => {
                this.collapsed = !this.collapsed
            })
        })

        this.checkFitting()
    },
    watch: {
        collapsed: {
            handler () {
                if (this.$el) {
                    this.$el.style.removeProperty('max-height')
                    this.$el.style.setProperty('max-height', this.eHeight, 'important')
                    this.checkFitting()
                }
            },
        },
    },
    destroyed () {
        if (window.__odrBus) {
            window.__odrBus.$off('possible-resize', this.checkFitting)
        }
    },
    methods: {
        checkFitting () {
            this.$nextTick(() => {
                if (this.$el && this.$refs.content) {
                    this.fits = !this.collapsed || (this.$refs.content.offsetHeight <= this.$el.offsetHeight)
                }
            })
        },

    },
    computed: {
        eHeight () {
            return !this.collapsed ? 'auto' : this.height
        },
        less () {
            return this.fits && !this.collapsed
        },
        more () {
            return !this.fits && this.collapsed
        },
    },
}
</script>
